import { columnContentWidth, columnFitDecision, columnFitNeeded } from '../../../shared/column-format'

// A column can keep a sideways scroll, or switch to the mobile layout once
// the normal layout is wider than the column. The remembered width stops the
// smaller mobile layout from switching straight back.

const columnFitMixin = {
  data () {

    return {
      columnFitState: { narrow: false },
      columnNeededWidth: 0,
      columnFitObserver: null,
      columnFitMutations: null
    }
  },
  provide () {

    return { columnFitState: this.columnFitState }
  },
  watch: {
    columnFormat: {
      deep: true,
      handler () {

        this.queueColumnFit()
      }
    },
    formComponents () {

      this.queueColumnFit(true)
    }
  },
  mounted () {

    this.observeColumnFit()
  },
  beforeUnmount () {

    this.releaseColumnFit()
  },
  methods: {
    columnOverflowMode () {

      return this.columnFormat && this.columnFormat.overflow === 'mobile' ? 'mobile' : 'scroll'
    },
    observeColumnFit () {

      this.releaseColumnFit()

      if (typeof ResizeObserver !== 'function') {

        this.measureColumnFit()
        return
      }

      this.columnFitObserver = new ResizeObserver(() => this.queueColumnFit())

      if (this.$el) {

        this.columnFitObserver.observe(this.$el)
        this.columnFitMutations = new MutationObserver(() => this.queueColumnFit(true))
        this.columnFitMutations.observe(this.$el, { childList: true, subtree: true })
      }

      this.watchColumnContent()
      this.measureColumnFit()
    },
    watchColumnContent () {

      if (!this.$el || !this.columnFitObserver) return

      this.$el.querySelectorAll('table, .pivot-scroll, .cards-grid, .calendar-grid').forEach((node) => {

        this.columnFitObserver.observe(node)
      })
    },
    queueColumnFit (rewatch) {

      this.$nextTick(() => {

        if (rewatch) this.watchColumnContent()

        this.measureColumnFit()
      })
    },
    measureColumnFit () {

      const element = this.$el
      const available = element && element.clientWidth ? element.clientWidth : 0
      const needed = columnFitNeeded({
        narrow: this.columnFitState.narrow,
        recordedNeed: this.columnNeededWidth,
        contentWidth: columnContentWidth(element)
      })
      const next = columnFitDecision({
        overflow: this.columnOverflowMode(),
        available,
        needed,
        mobile: this.columnFitState.narrow,
        recordedNeed: this.columnNeededWidth
      })
      const wasNarrow = this.columnFitState.narrow

      this.columnFitState.narrow = next.mobile
      this.columnNeededWidth = next.recordedNeed

      if (wasNarrow && !next.mobile) this.queueColumnFit()
    },
    releaseColumnFit () {

      if (this.columnFitObserver) this.columnFitObserver.disconnect()

      if (this.columnFitMutations) this.columnFitMutations.disconnect()

      this.columnFitObserver = null
      this.columnFitMutations = null
    }
  }
}

export { columnFitMixin }
